import { useMutation } from '@tanstack/react-query';
import { loaders } from './ai-image-generation.loaders';

export const useGenerateImage = () => {
  return useMutation(loaders.generateImage);
};
